// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionHeader_wrapper__HLl8i","header":"SectionHeader_header__3Kxnh","title":"SectionHeader_title__LXC5X"};